// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mJo0","top":"styles_top__N8UJc"};